import { TFunctionType, TranslationString } from 'shared/entities/localization';

import { SelectorEntities } from '../../components/Selector';
import { SkipGlobalInputsParamServer } from '../SkipGlobalInputsParam';
import { ConditionCmp } from '../../condition';
import {
  BlockBaseServer,
  BlockKind,
  BlockType,
  EditableAttrsBlockServer
} from '../common';

export enum ExprKind {
  EXPR = 'expr',
  VAR = 'var',
  MESSAGE = 'message',
  CHANNEL = 'channel',
  CHANNEL_KIND = 'channel_kind'
}

export const exprKindEntities: SelectorEntities<ExprKind, TranslationString> =
  Object.values(ExprKind).reduce<SelectorEntities<ExprKind, TranslationString>>(
    (acc, item) => ({
      ...acc,
      [item]: {
        id: item,
        title: (t: TFunctionType) =>
          t(`block.ConditionSwitchCase.exprKind.${item}`, {
            ns: 'entities'
          })
      }
    }),
    {} as SelectorEntities<ExprKind, TranslationString>
  );

export const exprKindIds = [
  ExprKind.MESSAGE,
  ExprKind.VAR,
  ExprKind.CHANNEL,
  ExprKind.CHANNEL_KIND,
  ExprKind.EXPR
];

export type CaseSimpleServer = {
  value: string;
  transition: string | null;
};

export type ConditionSwitchParamsServer = {
  cmp: ConditionCmp;
  cases: CaseSimpleServer[];
} & SkipGlobalInputsParamServer &
  (
    | {
        expr_kind: ExprKind.EXPR;
        expr: string;
      }
    | {
        expr_kind:
          | ExprKind.MESSAGE
          | ExprKind.CHANNEL_KIND
          | ExprKind.CHANNEL
          | ExprKind.VAR;
        expr: string | null;
      }
  );

export type ConditionSwitchServer = BlockBaseServer<
  BlockType.condition,
  BlockKind.conditionSwitch
> &
  EditableAttrsBlockServer<ConditionSwitchParamsServer>;
